import jrpc20WSClient from "./jrpc20WSClient";

class employee {
    TOKEN_LS_KEY = 'lt';
    USER_INFO_LS_KEY = 'user_info';

    token = null;
    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)

    constructor() {
        this.token = localStorage.getItem(this.TOKEN_LS_KEY);
    }

    // Cache locale solo per display (nome, qualifica_label): mai usarla per autorizzare.
    getUserInfo() {
        try {
            return JSON.parse(localStorage.getItem(this.USER_INFO_LS_KEY));
        } catch (e) {
            return null;
        }
    }

    saveUserInfo(info) {
        localStorage.setItem(this.USER_INFO_LS_KEY, JSON.stringify(info));
    }

    isLogged() {
        return new Promise((resolve, reject) => {
            if (this.token == null) {
                reject();
            } else {
                let post_data = {
                    user_data: {
                        token: this.token
                    },
                    call_data: {}
                };

                this.wsClient.request('post', 'employee/employee/checkToken', post_data).then((result) => {
                    const qualifica = result.call_data?.qualifica ?? null;

                    // Contratto scaduto/assente in sessione: la qualifica non e' piu'
                    // determinabile, la sessione non ha una sezione valida.
                    if (qualifica === null) {
                        this.logout();
                        reject();
                        return;
                    }

                    const cached = this.getUserInfo() || {};
                    this.saveUserInfo({
                        ...cached,
                        qualifica: qualifica,
                        qualifica_label: result.call_data?.qualifica_label ?? ''
                    });

                    resolve({
                        user_info: result.user_info,
                        qualifica: qualifica,
                        qualifica_label: result.call_data?.qualifica_label ?? ''
                    });
                }).catch((error) => {
                    reject(error);
                });
            }
        });
    }

    login(data) {
        return new Promise((resolve, reject) => {
            let post_data = {
                call_data: data
            };

            this.wsClient.request('post', 'employee/employee/login', post_data).then((result) => {
                this.token = result.call_data.token;
                localStorage.setItem(this.TOKEN_LS_KEY, this.token);

                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    // Login unificato con solo badge: il backend risolve la qualifica dal
    // contratto attivo e rifiuta chi non ne ha uno.
    authenticateBadge(data) {
        return new Promise((resolve, reject) => {
            let post_data = {
                call_data: data
            };

            this.wsClient.request('post', 'employee/employee/authenticateBadge', post_data).then((result) => {
                this.token = result.call_data.employee.token;
                localStorage.setItem(this.TOKEN_LS_KEY, this.token);

                this.saveUserInfo({
                    ...result.call_data.employee,
                    qualifica: result.call_data.qualifica,
                    qualifica_label: result.call_data.qualifica_label
                });

                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    authenticate(data) {
        return new Promise((resolve, reject) => {
            let post_data = {
                call_data: data
            };

            this.wsClient.request('post', 'production/orderProcessing/authenticate', post_data).then((result) => {

                this.token = result.call_data.employee.token;
                localStorage.setItem(this.TOKEN_LS_KEY, this.token);

                resolve(result.call_data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    logout() {
        this.token = null;
        localStorage.removeItem(this.TOKEN_LS_KEY);
        localStorage.removeItem(this.USER_INFO_LS_KEY);
    }



}

export default employee;
